import { render } from "./ImsisList.vue?vue&type=template&id=396fc0da&scoped=true"
import script from "./ImsisList.vue?vue&type=script&lang=js"
export * from "./ImsisList.vue?vue&type=script&lang=js"

import "./ImsisList.vue?vue&type=style&index=0&id=396fc0da&scoped=true&lang=css"
import "./ImsisList.vue?vue&type=style&index=1&id=396fc0da&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396fc0da"]])

export default __exports__